import { LoadingButton } from '@mui/lab';
import { CircularProgress, Stack } from '@mui/material';
import { t } from 'i18next';
import { SyntheticEvent, useState } from 'react';
import { PasswordInput } from '../../common/components/inputs/PasswordInput';
import { useFormItem } from '../../common/hooks/use-form-item';
import { InputType } from '../../common/hooks/use-form-item/types';
import { and } from '../../common/hooks/use-form-item/validators/compositions';
import { required } from '../../common/hooks/use-form-item/validators/existential';
import { maxLength } from '../../common/hooks/use-form-item/validators/operational';
import { LoginCredentials } from '../types';

type Props = {
  onSubmit: (loginCredentials: LoginCredentials) => Promise<void>;
};

export const LoginForm = ({ onSubmit }: Props) => {
  const [loading, setLoading] = useState(false);

  const [username, usernameComponent, isUsernameValid] = useFormItem<string>({
    type: InputType.TYPE_TEXT,
    label: t('usernameOrEmail'),
    value: '',
    validator: and(required(), maxLength(255)),
    inputOptions: {
      autoComplete: 'username email',
      autoFocus: true,
      disabled: loading,
      showRequiredIndicator: true,
    },
  });
  const [password, setPassword] = useState<string | null>(null);

  const areAllValid = isUsernameValid && !!password;

  const handleFormSubmission = async (e: SyntheticEvent) => {
    e.preventDefault();
    if (!areAllValid) return;

    setLoading(true);
    await onSubmit({ username, password });
    setLoading(false);
  };

  const loadingIndicator = (
    <span>
      <CircularProgress color="inherit" size={16} style={{ verticalAlign: 'middle' }} /> <span style={{ verticalAlign: 'middle' }}>{t('signIn')}</span>
    </span>
  );

  return (
    <Stack spacing={3} component="form" onSubmit={handleFormSubmission}>
      {usernameComponent}
      <PasswordInput name="current-password" label={t('password')} disabled={loading} onChange={setPassword} />
      <LoadingButton type="submit" variant="contained" loading={loading} loadingIndicator={loadingIndicator} style={{ width: '100%' }} disabled={!areAllValid}>
        {t('signIn')}
      </LoadingButton>
    </Stack>
  );
};
